// extracted by mini-css-extract-plugin
export default {"blurred":"BasePage_blurred__A9hbD"};